import { Environments, getApiEnvironment } from '@innovyze/stylovyze';

import config from './config.api';
import { formatUrlTrailing } from '@Utils/urlFormatting';

import { axiosWithHeaders, getService } from '@innovyze/lib_get_service';

const apiEnv =
	(localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

/**
 * Resolve the tiles base URL, honouring the `i-360-tileset-read-from-cloudos`
 * feature flag. When enabled, lib_get_service returns the CloudOS host
 * (`*.wlc360p-*.autodesk.com`); when disabled it returns the legacy
 * `info360-*` host. The flag is only applied if we forward it as the 4th
 * `featureFlags` argument to getService, hence this resolver.
 *
 * Feature flags are not known at import time, so callers must resolve this
 * lazily (at render/build time) with the live flag value rather than relying
 * on the module-level `tilesBaseUrl` constant below.
 */
export const getTilesBaseUrl = (
	isCloudOsTilesetEnabled: boolean,
	env: keyof typeof Environments | undefined = apiEnv,
): string =>
	formatUrlTrailing(
		getService('tiles', config, env, {
			'i-360-tileset-read-from-cloudos': isCloudOsTilesetEnabled,
		}),
	);

export const baseTilesUrl = getService('tiles', config, getApiEnvironment());

// Legacy default (flag OFF). Kept so the public tileOptions/tileOptionsV3/
// otherOptions objects and redux state resolve to the legacy host; the
// builders override the effective URL at runtime when the flag is on.
export const tilesBaseUrl = getTilesBaseUrl(false);

const tiles = axiosWithHeaders({
	service: 'tiles',
	config,
	axiosCreateOpts: {
		timeout: 3000,
	},
});

export default tiles;
